import {useCallback} from 'react';
import {GUEST_STATUSES, ShortGuest, isGuestVerificationPendingStatus} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {LeaderGuestFlag} from 'utils/guestForm';
import {useAuth} from 'hooks/auth/useAuth';
import {useIVOnProperty} from 'hooks/useIVOnProperty';
import {usePath} from 'hooks/common';

function useGuestNavigation() {
  const {getMainPath} = usePath();
  const {isIVOnPropertyAvailable} = useIVOnProperty();
  const {isLoggedIn} = useAuth();

  const getGuestUpdatePath = useCallback(
    (guest?: ShortGuest, isLeader?: boolean) => {
      const guestId = guest?.id;
      if (!guestId) return undefined;

      const guestStatus = guest?.guestapp_status;
      if (isGuestVerificationPendingStatus(guestStatus)) {
        return isIVOnPropertyAvailable
          ? getMainPath(
              `${PATHS.verification.main}/${guestId}/${PATHS.verification.qrScan}`,
            )
          : getMainPath(`${PATHS.verification.main}/${guestId}`);
      }

      const isPreRegisteredAndIncomplete =
        guest?.is_pre_registered && guestStatus === GUEST_STATUSES.incomplete;
      if (isPreRegisteredAndIncomplete || isLoggedIn) {
        return LeaderGuestFlag.appendToPath(
          getMainPath(`${PATHS.addPersonalDataForm}/${guestId}`),
          isLeader,
        );
      }

      return undefined;
    },
    [getMainPath, isIVOnPropertyAvailable, isLoggedIn],
  );

  return {getGuestUpdatePath};
}

export {useGuestNavigation};
